import React, { PureComponent } from 'react';
import { Query } from 'react-apollo';
import { styled } from "linaria/react";
import MaxWidth from '../Layout/MaxWidth';
import {StoreDetail} from './StoreDetail';
import storeLocatorQuery from '../StoreLocator/StoreLocator.gql';

import slugify from 'slugify'

import { theme } from "../Theme";

const Wrapper = styled(MaxWidth)`
padding:0!important;
  margin: 0 auto;
  font-size:14px;
  .directions-link {
        display: flex;
        padding-bottom: 10px;
        svg {
          max-width: 1rem;
          margin-right: 10px;
        }
      }
      a {
        margin-bottom: 10px;
        display: block;
        color: #000;
        font-weight: bold;
      }
  h1 {
    border-bottom: 3px solid #d2d2d2;
    padding-bottom: 5px;
    margin-bottom: 10px;
    line-height: 35px;
  }

  .more-stores {
    margin-bottom: 1rem;
    margin-top: 1rem;
    a {
      padding-top: 1rem;
      color: #000;
      text-decoration: none;
      text-align: center;
      background: #dedede;
      padding: 15px 25px;
      font-size: 14px;
      letter-spacing: 0.15em;
      text-transform: uppercase;
    }
  }
  
  & > div {
    max-width:600px;
    width:100%;
    margin: 0 auto;
    padding: 2rem;
    &:empty{
      display: none;
    }
    & > div {
      padding-top: 1rem;
    }
  }
  .map-container {
    max-width:100%;
    padding:0;
    min-height: 70vh;
    margin:0;

    ${theme.below.lg} {
      height: 50vh;
    }
  }
`;

export default class Store extends PureComponent {
  render() {
    const {
      match: {
        params: { slug: storeId }
      }
    } = this.props;
    return (
      <Query query={storeLocatorQuery}>
        {({ data, loading, error }) => {
          if (loading) return <Wrapper>Loading…</Wrapper>;
          if (error) return 'Something went wrong';
          
          const { stores } = data;
          const store = stores.find(store => {
            return slugify(store.name).toLowerCase() === storeId
          });
          return (
            <Wrapper>
              {!store ? 'No store found!' : <StoreDetail store={store} />}
            </Wrapper>
          );
        }}
      </Query>
    );
  }
}
